import * as types from "../../mutation-types";
import assinaturaApi from "../../../api/assinatura";

export const actions = {
  assinarPremium({ commit }, payload) {
    return assinaturaApi.assinarPremium(payload)
      .then(({ data }) => {
        commit(types.SET_USUARIO, data);
        return data
      });
  },
  cancelarAssinatura({ commit }) {
    return assinaturaApi.cancelarAssinatura()
      .then(({ data }) => {
        commit(types.SET_USUARIO, data);
      });
  },
  reativarAssinatura({ commit }) {
    return assinaturaApi.reativarAssinatura()
      .then(({ data }) => {
        commit(types.SET_USUARIO, data);
      });
  },
  getFaturas({ commit }) {
    return assinaturaApi.faturas()
      .then(({ data }) => {
        commit(types.SET_FATURAS, data);

        if (data.items.length > 0
          && data.items[0].status === "PENDENTE"
          && data.items[0].link_externo) {
          //&& typeof state.user.dados_assinatura !== 'undefined'
          //&& !state.user.dados_assinatura.esta_suspensa) {

          let dataVencimentoBoleto;
          if(data.items[0].data_vencimento) {
            dataVencimentoBoleto = data.items[0].data_vencimento.date
          } else {
            dataVencimentoBoleto =  data.items[0].data.date
          }

          let date = moment(dataVencimentoBoleto);

          const message = `Seu boleto vence em ${date.format('DD/MM/YYYY')}. Clique para pagar (Desconsidere caso já tenha pago)`;
          const link = data.items[0].link_externo_boleto;

          commit(types.SET_MESSAGES, {message, link});
        }
      });
  },
  atualizarDadosCartao({ commit }, payload) {
    return assinaturaApi.atualizarDadosCartao(payload)
      .then(({ data }) => {
        commit(types.SET_USUARIO, data);
      });
  },
  getDadosCobranca({ commit }) {
    return assinaturaApi.getDadosCobranca()
      .then(({ data }) => {
        return data;
      });
  },
  atualizarDadosCobranca({ commit }, payload) {
    return assinaturaApi.atualizarDadosCobranca(payload)
      .then(({ data }) => {
        //commit(types.SET_USUARIO, data);
      });
  },
};
